// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1OIjJ","tab":"Tabs_tab__GCezC","tabActive":"Tabs_tabActive__10YaY"};